<template>
  <div class="w-full">
    <SparkMultiFilter
      name="materials"
      label="Materials"
      placeholder="Select materials"
      :options="materialOptions"
      v-model="selectedMaterialValues"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SparkMultiFilter from '@/components/SparkComponents/SparkMultiFilter.vue';

export default {
  name: 'MaterialFilter',

  components: {
    SparkMultiFilter,
  },

  props: {
    reset: { type: Number, required: true },
    parent: { type: String, required: true },
  },

  emits: ['selected'],

  data() {
    return {
      selectedMaterialValues: [],
      materialOptions: [],
    };
  },

  computed: {
    ...mapState(['partLibraryFilters']),
    ...mapState('application', ['axiosInstance']),
  },

  watch: {
    selectedMaterialValues: {
      handler(newVal) {
        // Convert the selected IDs back to names for the API
        const selectedMaterials = this.materialOptions
          .filter(option => newVal.includes(option.value))
          .map(option => option.label.replace(' ⭐', '')); // Remove star from label
        this.$emit('selected', { materials: selectedMaterials });
      },
      deep: true,
    },

    reset: {
      handler() {
        if (this.reset) {
          this.clear();
        }
      },
      immediate: true,
    },
  },

  async mounted() {
    await this.getMaterials();
    const filter = JSON.parse(sessionStorage.getItem('libraryFilter'));
    if (this.parent === 'library') {
      const selected = filter?.materials;
      if (selected?.length) {
        // Convert material names to option values
        const selectedValues = this.materialOptions
          .filter(option => selected.includes(option.label.replace(' ⭐', '')))
          .map(option => option.value);
        this.selectedMaterialValues = selectedValues;
      }
    }
  },

  methods: {
    ...mapMutations(['resetFilter']),

    async getMaterials() {
      await this.axiosInstance
        .get('/api/v1/materials-dropdown/')
        .then(response => {
          const materialMap = new Map();
          response.data.forEach(entry => {
            if (!materialMap.has(entry.mat_name)) {
              materialMap.set(entry.mat_name, {
                mat_id: entry.mat_id,
                name: entry.mat_name,
                favorite: entry.favorite,
              });
            }
          });
          
          // Convert to options format for SparkMultiFilter
          const materials = Array.from(materialMap.values());
          materials.push({ mat_id: 'no-material', name: 'No Material', favorite: false });
          
          this.materialOptions = materials.map(material => ({
            value: material.mat_id,
            label: material.name + (material.favorite ? ' ⭐' : ''), // Add star for favorites
          }));
        })
        .catch(error => {
          console.log(error);
        });
    },

    clear() {
      this.resetFilter({ materials: 'materials' });
      this.selectedMaterialValues = [];
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  font-size: var(--12px);
}

.multiselect__tags {
  padding: 5px 40px 0px 3px;
}

.multiselect__tag {
  padding: 0px;
  font-size: var(--9px);
}

.multiselect__input {
  font-size: var(--9px);
}
</style>
